import React from 'react'
import { navigateTo } from 'gatsby-link'
import styled, { css } from 'styled-components'
import { VelocityComponent } from 'velocity-react'
import Link from 'gatsby-link'

import { media } from '../../../styles/utils'
import { container, bgIcon, padding, hoverState, bgImage } from '../../../styles/global'
import { ribbon, grey } from '../../../styles/colors';
import { paragraph } from '../../../styles/type';

class BlockText extends React.Component {

	state = {
	
	}
	
	render() {
        const { paragraph } = this.props;
        
		return (
            <Text
                dangerouslySetInnerHTML={{__html: paragraph}}  
            />
		)
	}
}


const Text = styled.div`
	width: 440px;
	max-width: 100%;
	${padding};
	box-sizing: content-box;
	
	${media.laptop`
		width: 346px;
	`}

	${media.tablet`
		width: 60rem;
	`}
	
	> * {
		${paragraph};
	}
`

BlockText.wrapper = css`
	display: flex;
	justify-content: center;
	margin: 0 0 10rem;
`

export default BlockText



// WEBPACK FOOTER //
// ./src/components/Block/templates/BlockText.js